var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.83331H2.33333C1.59695 6.83331 1 7.43027 1 8.16665V12.8333C1 13.5697 1.59695 14.1666 2.33333 14.1666H11.6667C12.403 14.1666 13 13.5697 13 12.8333V8.16665C13 7.43027 12.403 6.83331 11.6667 6.83331Z",
    stroke: "#DB0F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 6.83331V4.16665C3.6665 3.28259 4.01769 2.43475 4.64281 1.80962C5.26794 1.1845 6.11578 0.833313 6.99984 0.833313C7.88389 0.833313 8.73174 1.1845 9.35686 1.80962C9.98198 2.43475 10.3332 3.28259 10.3332 4.16665V6.83331",
    stroke: "#DB0F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLock);
export default __webpack_public_path__ + "static/media/red-lock.7e0e108fecd3e4873082e022072d4ce3.svg";
export { ForwardRef as ReactComponent };